<template>
  <div class="user_list_page">

    <business-group :tableConfig="{ ...tableConfig }" :formConfig="{ ...formConfig }" ref="businessGroup">
      <!-- 查询 -->
      <template slot="formSlot" slot-scope="formSlot">
        <a-form-item>
          <a-input placeholder="请输入型号名称" v-decorator="['modelName']" style="width: 200px; margin-right: 10px; vertical-align: middle" />
        </a-form-item>
        <a-form-item>
          <a-input placeholder="请输入设备型号" v-decorator="['deviceModel']" style="width: 200px; margin-right: 10px; vertical-align: middle" />
        </a-form-item>
        <a-form-item>
          <a-input placeholder="请输入固件版本号" v-decorator="['firmwareVersion']" style="width: 200px; margin-right: 10px; vertical-align: middle" />
        </a-form-item>
      </template>
      <!-- 新增 -->
      <template slot="formRight">
        <a-button type="primary" @click="showAddForm">新增</a-button>
      </template>
      <!-- 创建时间格式化 -->
      <template slot="createTime" slot-scope="record">
        {{ dataFormatStr(record.createTime, "YYYY-MM-DD HH:mm:ss") }}
      </template>
      <!-- 修改时间格式化 -->
      <template slot="updateTime" slot-scope="record">
        {{ dataFormatStr(record.updateTime, "YYYY-MM-DD HH:mm:ss") }}
      </template>
      <!-- 操作 -->
      <template slot="action" slot-scope="record">
        <a-button type="link" @click="() => showUpdateForm(record)">修改</a-button>
        <a-button type="link" @click="() => deleted(record)">删除</a-button>
      </template>
    </business-group>

    <!--  添加固件版本号弹窗  -->
    <a-modal title="添加固件版本号" destroyOnClose :visible="addVisible" :maskClosable="false" @ok="add" @cancel="() => addVisible = false">
      <a-form-model :modal="addColorVersionFrom" layout="vertical" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="定时颜色固件版本:">
          <a-input placeholder="请输入定时颜色固件版本" v-model.trim="addColorVersionFrom.firmwareVersion" showCount :maxlength="64" style="float: none"/>
        </a-form-model-item>
        <a-form-model-item label="请选择设备型号:">
          <a-select placeholder="请选择设备型号" v-decorator="['deviceModels']" v-model="addColorVersionFrom.deviceModel">
            <a-select-option v-for="item in deviceModels" :value="item.deviceModel" :key="item.deviceModel" style="float: none">
              <a-row type="flex">
                  <a-col :span="5" :order="1">{{ item.modelName }}</a-col>
                  <a-col :span="6" :order="2">{{ item.deviceModel }}</a-col>
                  <a-col :span="8" :order="3">{{ item.deviceDescription }}</a-col>
              </a-row>
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!--  修改固件版本号弹窗  -->
    <a-modal title="修改固件版本号" destroyOnClose :visible="updateVisible" :maskClosable="false" @ok="update" @cancel="() => updateVisible = false">
      <a-form-model :modal="updateColorVersionFrom" layout="vertical" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="id:" v-show="false">
          <a-input placeholder="id" v-model="updateColorVersionFrom.id" showCount :maxlength="64" />
        </a-form-model-item>
        <a-form-model-item label="定时颜色固件版本:">
          <a-input placeholder="请输入定时颜色固件版本" v-model="updateColorVersionFrom.firmwareVersion" showCount :maxlength="64" />
        </a-form-model-item>
        <a-form-model-item label="请选择设备型号:">
          <a-select placeholder="请选择设备型号" v-decorator="['deviceModels']" v-model="updateColorVersionFrom.deviceModel" style="float: none">
            <a-select-option v-for="item in deviceModels" :value="item.deviceModel" :key="item.deviceModel">
              <a-row type="flex">
                <a-col :span="5" :order="1">{{ item.modelName }}</a-col>
                <a-col :span="6" :order="2">{{ item.deviceModel }}</a-col>
                <a-col :span="8" :order="3">{{ item.deviceDescription }}</a-col>
              </a-row>
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

  </div>
</template>

<script>
import pageTitle from "@/components/business/pageTitle";
import businessGroup from "@/components/business/businessGroup";
import { deviceType } from "@/utils/pageMaps";
import { tips } from "@/utils/util";
import { formatToStr } from "@/utils/dateUtils";

export default {
  created() {
    // 查询设备类型，下拉选项数据
    this.getDeviceModels();
  },
  components: {
    pageTitle,
    businessGroup
  },
  data() {
    return {
      deviceModels: [],
      deviceType,
      tableConfig: {
        url: "bluetoothlight/web/router/neewerhome/manage/scene/auto-timing-color/pages",
        rowKey: "id",
        columns: [
          {
            title: "主键ID",
            dataIndex: "id",
            key: "id",
            align: "left"
          },
          {
            title: "型号名称",
            dataIndex: "modelName",
            key: "modelName",
            align: "left"
          },
          {
            title: "设备型号",
            dataIndex: "deviceModel",
            key: "deviceModel",
            align: "left"
          },
          {
            title: "使用说明",
            dataIndex: "deviceDescription",
            key: "deviceDescription",
            align: "left"
          },
          {
            title: "定时颜色固件版本",
            dataIndex: "firmwareVersion",
            key: "firmwareVersion",
            align: "left"
          },
          {
            title: "时间",
            key: "createTime",
            scopedSlots: { customRender: "createTime" },
            align: "left"
          },
          {
            title: "修改时间",
            key: "updateTime",
            scopedSlots: { customRender: "updateTime" },
            align: "left"
          },
          {
            title: "操作",
            align: "center",
            width: 150,
            scopedSlots: { customRender: "action" }
          }
        ]
      },
      formConfig: {
        timeShow: false,
        formShow: true
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 30 },
      addVisible: false,
      updateVisible: false,
      // 添加固件版本号表单
      addColorVersionFrom: {
        firmwareVersion: "",
        deviceModel: ""
      },
      // 修改固件版本号表单
      updateColorVersionFrom: {
        id: "",
        firmwareVersion: "",
        deviceModel: ""
      }
    };
  },
  methods: {
    // 时间格式化
    dataFormatStr(ret, format) {
      if (!ret) {
        return "";
      }
      if (!format) {
        format = "YYYY-MM-DD HH:mm:ss";
      }
      return formatToStr(ret, format);
    },
    // 添加弹窗
    showAddForm: function() {
      this.addColorVersionFrom = {
        firmwareVersion: "",
        deviceModel: ""
      };
      this.addVisible = true;
    },
    // 添加固件版本号
    add: async function() {
      let url = "bluetoothlight/web/router/neewerhome/manage/scene/auto-timing-color/add";
      try {
        const result = await this.$post(url, this.addColorVersionFrom);
        const resultStatus = result?.resultStatus;
        if (resultStatus) {
          tips(this, true);
          this.refreshData();
          this.addVisible = false;
        }
      } catch (error) {
        console.error("添加固件版本号时发生错误:", error);
        tips(this, false, "添加固件版本号时发生错误");
      }
    },

    // 添加弹窗
    showUpdateForm: function(record) {
      this.updateColorVersionFrom = {
        id: record.id,
        firmwareVersion: record.firmwareVersion,
        deviceModel: record.deviceModel
      };
      this.updateVisible = true;
    },
    // 修改固件版本号
    update: async function() {
      let url = "bluetoothlight/web/router/neewerhome/manage/scene/auto-timing-color/update";
      try {
        const result = await this.$post(url, this.updateColorVersionFrom);
        const resultStatus = result?.resultStatus;
        if (resultStatus) {
          tips(this, true);
          this.refreshData();
          this.updateVisible = false;
        }
      } catch (error) {
        console.error("修改固件版本号时发生错误:", error);
        tips(this, false, "修改固件版本号时发生错误");
      }
    },

    // 删除固件版本号
    deleted: async function(record) {
      let url = "bluetoothlight/web/router/neewerhome/manage/scene/auto-timing-color/delete";
      try {
        const result = await this.$get(url, { "id": record.id });
        const resultStatus = result?.resultStatus;
        if (resultStatus) {
          tips(this, true);
          this.refreshData();
          this.updateVisible = false;
        }
      } catch (error) {
        console.error("删除固件版本号时发生错误:", error);
        tips(this, false, "删除固件版本号时发生错误");
      }
    },

    // 查询设备类型，下拉选项数据
    getDeviceModels: async function() {
      let url = "bluetoothlight/web/router/neewerhome/manage/device/classification/get";
      const result = await this.$get(url);
      this.deviceModels = result?.resultData || [];
    },

    // 刷新列表数据
    refreshData() {
      this.$refs?.["businessGroup"]?.getData?.();
    }
  }
};
</script>


<style lang="less" scoped>
.user_list_page {
  .list_button {
    width: 80px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border: none;
    color: #fff;
    font-size: 12px;
    border-radius: 5px;
    margin-right: 10px;
  }
}

::v-deep .ant-select-selection-selected-value {
  float: none;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
  